(() => {
  if (window.productReelAutoplayInitialized) return;
  window.productReelAutoplayInitialized = true;

  const videos = new Map();
  const load = video => {
    if (video.dataset.src) {
      video.src = video.dataset.src;
      delete video.dataset.src;
      video.load();
    }
  };
  const update = (video, visible) => {
    if (!visible || document.hidden) {
      video.pause();
      return;
    }
    load(video);
    video.muted = true;
    const play = video.play();
    if (play) play.catch(() => {
      // Keep playback available if the browser declines muted autoplay.
      video.controls = true;
    });
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        videos.set(entry.target, visible);
        update(entry.target, visible);
      });
    }, { threshold: [0, 0.25] })
    : null;

  const init = (root) => {
    root.querySelectorAll('video[data-product-reel-autoplay]').forEach(video => {
      if (videos.has(video)) return;
      video.muted = true;
      video.playsInline = true;
      videos.set(video, false);
      if (observer) observer.observe(video);
      else {
        load(video);
        video.controls = true;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    videos.forEach((visible, video) => {
      if (!event.target.contains(video)) return;
      video.pause();
      if (observer) observer.unobserve(video);
      videos.delete(video);
    });
  });
  document.addEventListener('visibilitychange', () => {
    videos.forEach((visible, video) => update(video, visible));
  });
})();
